var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 6.25C10.75 6.25 11.75 6.75 11.75 8C11.75 9.25 10.75 9.75 10.75 9.75M11.75 3.25C13.75 4.25 14.75 5.75 14.75 8C14.75 10.25 13.75 11.75 11.75 12.75M1.75 5.75V10.25H4.25L8.25 13.25V2.75L4.25 5.75H1.75Z",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSound);
export default __webpack_public_path__ + "static/media/ICON_SOUND.9a9913b1a32677b1a02918f22d136053.svg";
export { ForwardRef as ReactComponent };